module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/product-images/product-01-0d97d419b110ae56376ad9f20d804b2f.jpg";